import TipoCentroCostoService from 'src/modules/tipoCentroCosto/tipoCentroCostoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TIPOCENTROCOSTO_VIEW';

const tipoCentroCostoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoCentroCostoViewActions.FIND_STARTED,
      });

      const record = await TipoCentroCostoService.find(id);

      dispatch({
        type: tipoCentroCostoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoCentroCostoViewActions.FIND_ERROR,
      });

      getHistory().push('/tipo-centro-costo');
    }
  },
};

export default tipoCentroCostoViewActions;
